import { gql } from '@apollo/client'

export const CHART = gql`
  query Chart($goalId: Int) {
    chart(goalId: $goalId) {
      calculationType
      id
      target
      title
      unitOfMeasurement
      goalId
      seriesData {
        data {
          x
          y
        }
        title
      }
    }
  }
`
